import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {ErrorHandlerService} from "../../../error-handler.service";
import {CustomerInstanceVenueModel} from "../customer-instance-venue.model";
import {VenueAddressService} from "./venue-address.service";
import {VenueAddress} from "./venue-address.data";
import {Subscription} from "rxjs";

@Component({
    selector: "fhm-venue-address",
    styles: [":host {display: flex; width: 100%;}"],
    templateUrl: "./venue-address.component.html",
    styleUrls: ["./venue-address.component.scss"],
    providers: [VenueAddressService],
    standalone: false
})
export class VenueAddressComponent implements OnInit, OnDestroy {

    data: VenueAddress;

    editing: boolean;

    subscription: Subscription = new Subscription();

    @Input() formGroupAddress: FormGroup;

    constructor(private errorHandler: ErrorHandlerService,
                public model: CustomerInstanceVenueModel,
                private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.subscription.add(this.model.data$.subscribe(() => {
            this.changeDetectorRef.detectChanges();
            this.data = this.model.draft ? this.model.data.address : Object.assign({}, this.model.data.address);
            this.editing = this.model.draft || this.newEntity;
        }));
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    async save(): Promise<void> {
        if (this.formGroupAddress.valid) {
            try {
                await this.model.saveAddress(this.data);
                this.editing = false;
            } catch (e) {
                this.errorHandler.handleErrorResponse(e);
            }
        }
    }

    edit(): void {
        this.editing = true;
    }

    cancelEdit(): void {
        this.data = Object.assign({}, this.model.data.address);
        this.editing = false;
    }

    get newEntity(): boolean {
        return !this.data.id;
    }
}
